module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-select', {
    attrs: {
      "items": _vm.servicesList,
      "label": "Add on items select",
      "item-value": "id",
      "item-text": "name",
      "return-object": "",
      "multiple": "",
      "attach": "",
      "clearable": "",
      "hide-selected": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_vm._v("\n      Product: " + _vm._s(props.item.name) + " | Category: " + _vm._s(props.item.category.name) + "\n    ")]
      }
    }, {
      key: "selection",
      fn: function(props) {
        return [_c('span', {
          staticClass: "v-chip v-chip--select-multi theme--light"
        }, [_c('span', {
          staticClass: "v-chip__content"
        }, [_vm._v("\n          " + _vm._s(props.item.name) + "\n        ")])])]
      }
    }]),
    model: {
      value: (_vm.mutableSelectedServices),
      callback: function($$v) {
        _vm.mutableSelectedServices = $$v
      },
      expression: "mutableSelectedServices"
    }
  }), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.mutableSelectedServices,
      "headers": _vm.productsTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-layout', {
          attrs: {
            "justify-space-between": "",
            "align-center": ""
          }
        }, [(_vm.upgrade_id === props.item.id) ? _c('v-select', {
          attrs: {
            "items": _vm.getProductsByCategoryId(props.item.categories_id),
            "label": "Select Another Product from same category"
          },
          on: {
            "change": function($event) {
              return _vm.changeProductFromCategory(props.item)
            }
          },
          model: {
            value: (_vm.change_product_from_category_model),
            callback: function($$v) {
              _vm.change_product_from_category_model = $$v
            },
            expression: "change_product_from_category_model"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.upgrade_id !== props.item.id) ? _c('span', [_vm._v("\n                  " + _vm._s(props.item.name) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.upgrade_id !== props.item.id) ? _c('v-btn', {
          attrs: {
            "small": "",
            "align-rigth": ""
          },
          on: {
            "click": function($event) {
              _vm.upgrade_id = props.item.id
            }
          }
        }, [_vm._v("Upgrade")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "quantity_bgcolor"
        }, [_c('v-edit-dialog', {
          attrs: {
            "return-value": props.item.amount,
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          on: {
            "update:returnValue": function($event) {
              return _vm.$set(props.item, "amount", $event)
            },
            "update:return-value": function($event) {
              return _vm.$set(props.item, "amount", $event)
            }
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Quantity",
                  "single-line": "",
                  "autofocus": ""
                },
                model: {
                  value: (props.item.amount),
                  callback: function($$v) {
                    _vm.$set(props.item, "amount", $$v)
                  },
                  expression: "props.item.amount"
                }
              })]
            },
            proxy: true
          }], null, true)
        }, [_c('div', [_vm._v(_vm._s(props.item.amount))])])], 1), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.amount * props.item.price))]), _vm._v(" "), _c('td', {
          staticClass: "justify-center layout px-0"
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteItem(props.item)
            }
          }
        }, [_vm._v("\n          delete\n        ")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('template', {
    slot: "footer"
  }, [(_vm.discount) ? _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Remarks in $",
      "type": "number"
    },
    model: {
      value: (_vm.discountValue),
      callback: function($$v) {
        _vm.discountValue = $$v
      },
      expression: "discountValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.price) ? _c('v-flex', {
    attrs: {
      "tag": "h3"
    }
  }, [_vm._v("\n        Final price: $" + _vm._s(_vm.finalPrice) + "\n      ")]) : _vm._e()], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-673ddafa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatables/ServicesDataTable.vue
// module id = 1001
// module chunks = 1